module.exports = __webpack_public_path__ + "static/media/happy_batteries.6d93bf9d.svg";